import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import payments from "./paymentsReducer";
import domiciliationReducer from "./domiciliationReducer";
import favoritesRefReducer from "./favoritesRefReducer";
import payReminderReducer from "./payReminderReducer";
import aploanReducer from "./aploan";
import messagingReducer from "./messaging";

export default combineReducers({
  payments,
  domiciliationReducer,
  favoritesRefReducer,
  payReminderReducer,
  aploanReducer,
  messagingReducer,
  router: routerReducer,
});
